"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctolibImportApiResponseSchema = void 0;
const zod_1 = require("zod");
const doctolibAmountSchema = zod_1.z.preprocess((value) => typeof value === 'string' && value.trim() === '' ? undefined : value, zod_1.z.coerce.number());
exports.getDoctolibImportApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    periodFrom: zod_1.z.string(),
    periodTo: zod_1.z.string(),
    workScheduleDoctolibData: zod_1.z
        .array(zod_1.z.object({
        date: zod_1.z.string(),
        invoiceIdentifier: zod_1.z.string(),
        totalAmountDue: doctolibAmountSchema,
        totalAmountPaid: doctolibAmountSchema,
    }))
        .nullable(),
});
